<template>
  <div>
    <div class="navbar-section fixed-top w-100 index-99" :class="color_theme">
      <!-- DESKTOP SCREEN VIEW -->
      <div class="container h-auto d-none d-md-block">
        <div
          class="row d-flex justify-content-between align-items-center nowrap"
        >
          <!-- BRAND LOGO -->
          <div class="brand-logo">
            <router-link
              :to="'/' + nav_type + '/dashboard'"
              v-if="nav_type === 'school'"
            >
              <img v-lazy="localImg('Gradely.svg')" alt="Gradely.ng" />
            </router-link>
            <template v-else>
              <template v-if="nav_type === 'teacher'">
                <router-link :to="'/' + nav_type + '/feeds/' + getCurrentClass">
                  <img v-lazy="localImg('Gradely.svg')" alt="Gradely.ng" />
                </router-link>
              </template>

              <template v-else>
                <router-link
                  :to="'/' + nav_type + '/feeds/' + getSelectedChildID"
                >
                  <img v-lazy="localImg('Gradely.svg')" alt="Gradely.ng" />
                </router-link>
              </template>
            </template>
          </div>

          <!-- NAVIGATION -->
          <div
            class="nav-items d-flex justify-content-center align-items-center nowrap"
            v-if="show_nav && color_theme === 'white'"
          >
            <div
              class="nav-item"
              v-for="(text, index) in nav_text"
              :key="index"
            >
              <template v-if="nav_type === 'school'">
                <router-link
                  :to="{ name: nav_name[index] }"
                  :class="nav_active[index] ? 'active' : ''"
                >
                  <span :class="nav_icon[index]"></span>
                  <div class="nav-text">{{ text }}</div>
                </router-link>
              </template>

              <template
                v-else-if="nav_type === 'parent' || nav_type === 'student'"
              >
                <router-link
                  :to="{
                    name: nav_name[index],
                    params: { id: getSelectedChildID },
                  }"
                  :class="nav_active[index] ? 'active' : ''"
                >
                  <span :class="nav_icon[index]"></span>
                  <div class="nav-text">{{ text }}</div>
                </router-link>
              </template>

              <template v-else>
                <router-link
                  :to="{
                    name: nav_name[index],
                    params: { id: getCurrentClass },
                  }"
                  :class="nav_active[index] ? 'active' : ''"
                >
                  <span :class="nav_icon[index]"></span>
                  <div class="nav-text">{{ text }}</div>
                </router-link>
              </template>
            </div>
          </div>

          <!-- DARK THEME -->
          <div
            class="nav-items d-flex justify-content-center align-items-center nowrap"
            v-if="show_nav && color_theme === 'black'"
          >
            <div
              class="nav-item"
              v-for="(text, index) in nav_text"
              :key="index"
            >
              <router-link
                :to="{ name: nav_name[index] }"
                class="dark-nav-item"
                :class="nav_active[index] ? 'dark-active' : ''"
              >
                <span :class="nav_icon[index]"></span>
                <div class="nav-text">{{ text }}</div>
              </router-link>
            </div>
          </div>
          <!-- NAVIGATION -->

          <!-- MORE ICONS -->
          <div class="more-icons d-flex justify-content-end align-items-center">
            <!-- ICON SEARCH -->
            <!--<div class="icon avatar avatar-square" v-if="nav_type==='school'">
              <span class="icon-search"></span>
            </div>-->

            <!-- ICON MESSAGE -->
            <!-- <div
              class="icon avatar avatar-square"
              v-if="nav_type==='parent' || nav_type==='teacher'"
            >
              <router-link :to="'/'+nav_type+'/message'">
                <span class="icon-message brand_navy"></span>
              </router-link>
            </div>-->

            <!-- ICON NOTIFICATION -->
            <div
              v-if="false"
              class="icon avatar avatar-square hint--primary hint--rounded hint--left"
              aria-label="Notifications"
              style="overflow: unset"
              @click="toggleNotifications"
            >
              <span class="icon-bell"></span>
              <div class="badge-circle brand_red_bg index-9"></div>
            </div>

            <!-- ICON SETTINGS SCHOOL TYPE  -->
            <div
              class="icon avatar avatar-square hint--primary hint--rounded hint--left"
              aria-label="User Setup"
              style="overflow: unset"
              v-if="nav_type === 'school'"
            >
              <span
                class="icon-gear"
                v-on-clickaway="onSlideOut"
                @click.self="toggleSettings"
              ></span>
            </div>

            <!-- ICON AVATAR TEXT -->
            <div
              class="icon rounded-5 icon__user"
              :class="setAvatarBg"
              v-on-clickaway="onUserSlideOut"
              @click="toggleUserSettings"
              v-if="nav_type === 'parent' || nav_type === 'teacher'"
            >
              <img
                v-lazy="user_image"
                :alt="user_full_name | getInitials"
                v-if="user_image"
                :class="setAvatarBg"
              />
              <div
                v-else
                class="avatar-text white-text font-10-5"
                :class="setAvatarBg"
              >
                {{ user_full_name | getInitials }}
              </div>
              <i
                class="icon-caret-fill-down color_grey_light font-5"
                v-if="is_catchup"
              ></i>
              <i class="icon-caret-fill-down color_text font-5" v-else></i>
            </div>

            <!-- STUDENT AVATAR -->
            <div
              class="icon rounded-5 icon__user hint--primary hint--rounded hint--bottom"
              aria-label="User Setup"
              style="overflow: unset"
              :class="[nav_type === 'student' ? 'brand_navy_bg' : '']"
              v-on-clickaway="onUserSlideOut"
              @click="toggleUserSettings"
              v-if="nav_type === 'student'"
            >
              <img
                v-lazy="user_image"
                :alt="user_full_name | getInitials"
                v-if="user_image"
              />
              <div
                v-else
                class="avatar-text white-text font-10-5"
                :class="[nav_type === 'student' ? 'brand_navy_bg' : '']"
              >
                {{ user_full_name | getInitials }}
              </div>
              <i
                class="icon-caret-fill-down color_grey_light font-5"
                v-if="is_catchup"
              ></i>
              <i class="icon-caret-fill-down color_text font-6" v-else></i>
            </div>
          </div>
          <!-- MORE ICONS -->
        </div>
      </div>
    </div>

    <!-- SETTINGS PANEL -->
    <!-- DESKTOP -->
    <SettingsPanel
      :user_name="user_full_name"
      :school_name="user_school_name"
      :email="user_email"
      :student_code="user_code"
      :panel_image="user_image"
      :panel_type="nav_type"
      v-if="slide_panel"
      @onClose="slide_panel = false"
    ></SettingsPanel>

    <!-- MOBILE VIEW -->
    <SettingsPanel
      :user_name="user_full_name"
      :school_name="user_school_name"
      :email="user_email"
      :student_code="user_code"
      :panel_image="user_image"
      :panel_type="nav_type"
      v-if="slide_user_panel"
      @onClose="slide_user_panel = false"
    ></SettingsPanel>

    <!-- NOTIFICATION MODAL -->
    <NotificationsModal
      v-if="notification_modal"
      @closeTriggered="toggleNotifications"
    ></NotificationsModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SettingsPanel from "@/components/globalComps/SettingsPanel";
import { mixin as clickaway } from "vue-clickaway";
import { setProfileBg } from "@/scripts/profile-colors";

export default {
  name: "BaseNav",

  components: {
    SettingsPanel,
    NotificationsModal: () =>
      import(
        /* webpackChunkName: " NotificationsModal" */ "@/components/notificationComps/NotificationCover"
      ),
  },

  computed: {
    ...mapGetters(["getAuthUser", "getCurrentClass", "getSelectedChildID"]),

    setAvatarBg() {
      if (this.getAuthUser) return setProfileBg(this.user_full_name);
      else return false;
    },

    user_full_name() {
      if (this.getAuthUser) return this.getAuthUser.full_name;
      else return false;
    },

    user_school_name() {
      if (this.getAuthUser) return this.getAuthUser.school_name;
      else return false;
    },

    user_email() {
      if (this.getAuthUser) return this.getAuthUser.email;
      else return false;
    },

    user_image() {
      if (this.getAuthUser) {
        if (this.getAuthUser.image) return this.getAuthUser.image;
        else return false;
      } else return false;
    },

    user_code() {
      if (this.getAuthUser) return this.getAuthUser.code;
      else return false;
    },
  },

  mixins: [clickaway],

  props: {
    nav_text: Array,
    nav_icon: Array,
    nav_name: Array,
    nav_type: {
      type: String,
      default: "school",
    },
    show_nav: {
      type: Boolean,
      default: true,
    },
    color_theme: {
      type: String,
      default: "white",
    },
  },

  data() {
    return {
      nav_active: Array(4).fill(false),
      slide_panel: false,
      slide_user_panel: false,
      notification_modal: false,
      is_catchup: false,
    };
  },

  filters: {
    getInitials(val) {
      if (val) {
        const names = val.replace(/\s+/g, " ").split(" ");
        return names[0][0] + names[1][0];
      } else return "N/A";
    },
  },

  watch: {
    $route: "onRouteClick",
  },

  mounted() {
    let url = this.$router.currentRoute.name;
    this.activeRoute(url);
    this.checkIfCatchup();
  },

  methods: {
    activeRoute(url) {
      this.nav_active = Array(4).fill(false); //RESET THE ACTIVE NAV ARRAY TO FALSE

      let activeIndex = this.nav_name.findIndex((nav) => nav === url); //FIND THE INDEX OF THE CURRENT ROUTE

      if (
        url === "TeacherLibrary" ||
        url === "SchoolDashboardHomework" ||
        url === "SchoolDashboardExam" ||
        url === "SchoolDashboardLiveClass" ||
        url === "SchoolDashboardEvent"
      )
        this.nav_active[0] = true;
      this.nav_active[activeIndex] = true; //SET THE CURRENT ROUTE TO ACTIVE

      if (
        url === "StudentTopicTrend" ||
        url === "StudentTopicTrend_TP" ||
        url === "StudentProfile" ||
        url === "StudentProfile_TP" ||
        url === "ParentCatchupVideo" ||
        url === "ParentCatchupTutor" ||
        url === "StudentCatchupVideo" ||
        url === "StudentCatchupTutor" ||
        url === "StudentTutor" ||
        url === "ParentTutor"
      ) {
        this.nav_active[1] = true;
      } else if (
        url === "ParentHomeworkReview" ||
        url === "StudentHomeworkReview" ||
        url === "SchoolDashboardActivateStudent" ||
        url === "ParentVideos" ||
        url === "ParentNotes" ||
        url === "StudentVideos" ||
        url === "StudentNotes"
      ) {
        this.nav_active[2] = true;
      } else if (
        url === "StudentTopicTrend_PP" ||
        url === "StudentTopicTrend_SP"
      ) {
        this.nav_active[3] = true;
      }
    },

    checkIfCatchup() {
      let url = this.$route.path;
      if (url.includes("catchup")) this.is_catchup = true;
    },

    toggleSettings() {
      this.slide_panel = !this.slide_panel;
    },

    onSlideOut() {
      this.slide_panel = false;
    },

    onUserSlideOut() {
      this.slide_user_panel = false;
    },

    toggleUserSettings() {
      this.slide_user_panel = !this.slide_user_panel;
    },

    toggleNotifications() {
      this.notification_modal = !this.notification_modal;
    },

    onRouteClick() {
      this.active_route = this.$router.currentRoute.name;
      this.activeRoute(this.active_route);
    },
  },
};
</script>

<style></style>
